"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataTable = exports.MultiLineLinkWithIcon = exports.SingleLineLinkWithSubLinkIcon = exports.SingleLineLinkWithIcon = exports.MultiLineTextWithIcon = exports.SingleLineTextWithIcon = exports.getPaddingTopStyleForTextWithIcon = exports.ViewerPaneObfuscatedPlaceholder = void 0;
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../gen-src/Localize");
var LayoutComponents_1 = require("./style/LayoutComponents");
var LayoutStyles_1 = require("./style/LayoutStyles");
var StyleFunctions_1 = require("./style/StyleFunctions");
var TypescriptHelpers_1 = require("./utils/TypescriptHelpers");
var TextWithIconContainer = (0, LayoutComponents_1.divWithStyle)('TextWithIconContainer', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
});
var flexTextStyle = { flex: 1 };
var PrefixText = (0, LayoutComponents_1.divWithStyle)('PrefixText', {
    paddingRight: widgets_1.TabStyles.Spacing.SmallSpace
});
var SuffixText = (0, LayoutComponents_1.divWithStyle)('SuffixText', {
    paddingLeft: widgets_1.TabStyles.Spacing.SmallSpace
});
var SingleLineTextWithIconText = (0, LayoutComponents_1.divWithStyle)('SingleLineTextWithIconText', [LayoutStyles_1.elideTextStyle, flexTextStyle]);
// Multi-line for most browsers, this will elide the text to single line for IE only since it does not support break-word
var MultiLineTextWithIconText = (0, LayoutComponents_1.divWithStyle)('MultiLineTextWithIconText', [flexTextStyle, {
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-word'
    }]);
var TextWithIconIcon = (0, LayoutComponents_1.divWithStyle)('TextWithIconIcon', {
    display: 'flex',
    flexShrink: 0,
    paddingRight: widgets_1.TabStyles.Spacing.SmallSpace
});
function iconTitleProps(props) {
    var outputProps = {};
    if (props.iconTitle) {
        outputProps.title = props.iconTitle;
    }
    return outputProps;
}
function getAlignItemsStyle(iconPosition) {
    switch (iconPosition) {
        case 'top':
            return { alignItems: 'flex-start' };
        case 'middle':
            return { alignItems: 'center' };
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(iconPosition);
            return {};
    }
}
var ObfuscatedPlaceholder = (0, LayoutComponents_1.divWithStyle)('ObfuscatedPlaceholder', [LayoutStyles_1.elideTextStyle, {
        fontStyle: 'italic',
        color: widgets_1.TabStyles.Typography.Color.Secondary,
        paddingTop: widgets_1.TabStyles.Spacing.SmallSpace, // For alignment with the "Connects to" label
    }]);
function ViewerPaneObfuscatedPlaceholder() {
    return (react_1.default.createElement(ObfuscatedPlaceholder, { "data-tb-test-id": 'viewer-pane-obfuscated-placeholder-test-id' }, Localize_1.Messages.PermissionsRequired()));
}
exports.ViewerPaneObfuscatedPlaceholder = ViewerPaneObfuscatedPlaceholder;
function prefixElement(prefixText) {
    return prefixText ? react_1.default.createElement(PrefixText, null, prefixText) : null;
}
function suffixElement(suffixText) {
    return suffixText ? react_1.default.createElement(SuffixText, null, suffixText) : null;
}
function getPaddingTopStyleForTextWithIcon(iconProps) {
    var noPaddingTop = { paddingTop: 0 };
    var smallPaddingTop = { paddingTop: '3px' };
    switch (iconProps.iconSize) {
        case 'small':
            return noPaddingTop;
        case 'medium':
            return smallPaddingTop;
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(iconProps.iconSize);
            return {};
    }
}
exports.getPaddingTopStyleForTextWithIcon = getPaddingTopStyleForTextWithIcon;
function SingleLineTextWithIcon(props) {
    if (props.text === null) {
        return ViewerPaneObfuscatedPlaceholder();
    }
    return (react_1.default.createElement(TextWithIconContainer, null,
        prefixElement(props.prefixText),
        props.iconComponent ? react_1.default.createElement(TextWithIconIcon, __assign({}, iconTitleProps(props)), props.iconComponent) : null,
        react_1.default.createElement(SingleLineTextWithIconText, { title: props.text, style: getPaddingTopStyleForTextWithIcon(props) }, props.text),
        suffixElement(props.suffixText)));
}
exports.SingleLineTextWithIcon = SingleLineTextWithIcon;
function MultiLineTextWithIcon(props) {
    if (props.text === null) {
        return ViewerPaneObfuscatedPlaceholder();
    }
    var alignItemsStyle = getAlignItemsStyle(props.iconPosition);
    return (react_1.default.createElement(TextWithIconContainer, { style: alignItemsStyle },
        prefixElement(props.prefixText),
        props.iconComponent ? react_1.default.createElement(TextWithIconIcon, __assign({}, iconTitleProps(props)), props.iconComponent) : null,
        react_1.default.createElement(MultiLineTextWithIconText, { title: props.text, style: getPaddingTopStyleForTextWithIcon(props) }, props.text),
        suffixElement(props.suffixText)));
}
exports.MultiLineTextWithIcon = MultiLineTextWithIcon;
function SingleLineLinkWithIcon(props) {
    if (props.linkText === null) {
        return ViewerPaneObfuscatedPlaceholder();
    }
    return (react_1.default.createElement(TextWithIconContainer, null,
        prefixElement(props.prefixText),
        props.iconComponent ? react_1.default.createElement(TextWithIconIcon, __assign({}, iconTitleProps(props)), props.iconComponent) : null,
        react_1.default.createElement(SingleLineTextWithIconText, { title: props.linkText, style: getPaddingTopStyleForTextWithIcon(props) },
            react_1.default.createElement(widgets_1.TextLinkWidget, { href: props.linkHref, target: '_blank', testId: 'singleLineLinkWithIcon' }, props.linkText)),
        suffixElement(props.suffixText)));
}
exports.SingleLineLinkWithIcon = SingleLineLinkWithIcon;
function SingleLineLinkWithSubLinkIcon(props) {
    if (props.linkText === null) {
        return ViewerPaneObfuscatedPlaceholder();
    }
    return (react_1.default.createElement(TextWithIconContainer, null,
        prefixElement(props.prefixText),
        props.iconComponent ? react_1.default.createElement(TextWithIconIcon, __assign({}, iconTitleProps(props)), props.iconComponent) : null,
        react_1.default.createElement(SingleLineTextWithIconText, { title: props.linkText, style: getPaddingTopStyleForTextWithIcon(props) },
            react_1.default.createElement(widgets_1.TextLinkWidget, { href: props.linkHref, target: '_blank', testId: 'sinle-line-link-with-icon' }, props.linkText),
            props.subPrefixText,
            react_1.default.createElement(widgets_1.TextLinkWidget, { href: props.subLinkHref, target: '_blank', testId: 'single-line-with-icon-sublink' }, props.subLinkText),
            props.subSuffixText),
        suffixElement(props.suffixText)));
}
exports.SingleLineLinkWithSubLinkIcon = SingleLineLinkWithSubLinkIcon;
function MultiLineLinkWithIcon(props) {
    if (props.linkText === null) {
        return ViewerPaneObfuscatedPlaceholder();
    }
    var alignItemsStyle = getAlignItemsStyle(props.iconPosition);
    return (react_1.default.createElement(TextWithIconContainer, { style: alignItemsStyle },
        prefixElement(props.prefixText),
        props.iconComponent ? react_1.default.createElement(TextWithIconIcon, __assign({}, iconTitleProps(props)), props.iconComponent) : null,
        react_1.default.createElement(MultiLineTextWithIconText, { title: props.linkText, style: getPaddingTopStyleForTextWithIcon(props) },
            react_1.default.createElement(widgets_1.TextLinkWidget, { href: props.linkHref, target: '_blank', testId: 'multiLineLinkWithIcon' }, props.linkText)),
        suffixElement(props.suffixText)));
}
exports.MultiLineLinkWithIcon = MultiLineLinkWithIcon;
// eslint-disable-next-line @typescript-eslint/no-namespace
var MetadataTable;
(function (MetadataTable) {
    var valueCellFlexGrowClass = function (valueCellFlexGrow) {
        var _a;
        return (0, StyleFunctions_1.cssClass)("valueCellFlexGrow_".concat(valueCellFlexGrow), {
            '$nest': (_a = {},
                _a[".".concat(ValueCellClass)] = {
                    flex: valueCellFlexGrow,
                    minWidth: '0px'
                },
                _a)
        });
    };
    function Table(props) {
        var classNames = (0, StyleFunctions_1.classes)('MetadataTable', valueCellFlexGrowClass(props.valueCellFlexGrow));
        return (react_1.default.createElement("div", { className: classNames }, props.children));
    }
    MetadataTable.Table = Table;
    MetadataTable.Row = (0, LayoutComponents_1.divWithStyle)('MetadataTableRow', {
        display: 'flex',
        marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    });
    var LabelCellStyle = {
        flex: 1,
        flexShrink: 1,
        color: widgets_1.TabStyles.Typography.Color.Secondary,
        paddingRight: widgets_1.TabStyles.Spacing.MediumSpace,
    };
    MetadataTable.LabelCell = (0, LayoutComponents_1.divWithStyle)('MetadataTableLabelCell', LabelCellStyle);
    var ValueCellClass = (0, StyleFunctions_1.cssClass)('MetadataTableValueCell');
    function ValueCell(props) {
        return react_1.default.createElement("div", { className: ValueCellClass, "data-tb-test-id": props['data-tb-test-id'] }, props.children);
    }
    MetadataTable.ValueCell = ValueCell;
})(MetadataTable = exports.MetadataTable || (exports.MetadataTable = {}));
//# sourceMappingURL=ViewerPaneLayoutComponents.js.map